import { useCallback, useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import { RouterPaths } from '../../../app/appConstants';
import useEffectOnce from '../../../hooks/useEffectOnce.js';
import appHistory from '../../../app/appHistory.js';
import { resetPasswordAction } from '../authActions.js';
import { getPasswordResetErrorSelector, getPasswordResetOkSelector } from '../authSelectors.js';
import AuthWrapper from './AuthWrapper';
import { LoginStyled } from './styled/LoginStyled';

function Reset() {
    const { getLangPath } = useLangContext();
    const dispatch = useDispatch();
    const { search } = useLocation();
    const passwordResetOk = useSelector(getPasswordResetOkSelector);
    const passwordResetError = useSelector(getPasswordResetErrorSelector);

    const [email, setEmail] = useState('');
    const [code, setCode] = useState('');

    useEffect(() => {
        if (passwordResetOk) {
            appHistory.push(RouterPaths.login);
        }
    }, [passwordResetOk]);

    useEffectOnce(() => {
        const params = new URLSearchParams(search);
        setEmail(params.get('email'));
        setCode(params.get('code'));
        dispatch(
            resetPasswordAction({
                check: true,
                email: params.get('email'),
                code: params.get('code'),
            }),
        );
    });

    const submitHandler = useCallback(
        (e) => {
            e.preventDefault();
            dispatch(
                resetPasswordAction({
                    email,
                    code,
                    new_password: e.target.querySelector('[name=new_password]').value,
                    new_password_repeat: e.target.querySelector('[name=new_password_repeat]').value,
                }),
            );
        },
        [code, dispatch, email],
    );

    return (
        <AuthWrapper>
            <LoginStyled>
                <p className="section-eyebrow">{getLangPath('auth.brand')}</p>
                <h1 className="auth-title">{getLangPath('auth.reset_password.title_reset')}</h1>

                <Form onSubmit={submitHandler} className="mt-4">
                    <Form.Group className="mb-3" controlId="reset-new-password">
                        <Form.Label>{getLangPath('auth.reset_password.new_password')}</Form.Label>
                        <Form.Control
                            name="new_password"
                            type="password"
                            placeholder={getLangPath('auth.reset_password.new_password')}
                            required
                            autoFocus
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="reset-new-password-repeat">
                        <Form.Label>{getLangPath('auth.reset_password.new_password_repeat')}</Form.Label>
                        <Form.Control
                            name="new_password_repeat"
                            type="password"
                            placeholder={getLangPath('auth.reset_password.new_password_repeat')}
                            required
                        />
                    </Form.Group>

                    {!!passwordResetError && (
                        <p className="auth-error">{getLangPath(passwordResetError)}</p>
                    )}

                    <div className="auth-actions">
                        <Button variant="primary" size="lg" type="submit">
                            {getLangPath('auth.reset_password.save_password_button')}
                        </Button>
                    </div>
                </Form>
            </LoginStyled>
        </AuthWrapper>
    );
}

export default Reset;
